// extracted by mini-css-extract-plugin
module.exports = {"root":"_20Uqs","expertsListItem":"PFTff"};